import React from "react";
import Paragraph from "../common/ui/Paragraph";

const BlogCategories = () => {
  const list = [
    { category: "Uncategorized", count: 78 },
    { category: "Technology", count: 5 },
    { category: "Business & Marketing", count: 23 },
    { category: "Digital Agency", count: 10 },
  ];
  return (
    <div className="space-y-3">
      {list.map((obj, index) => (
        <div
          key={index}
          className="pb-[3px] border-b border-solid border-b-custom-black/5 ">
          <Paragraph variant="off-gray-2" className="">
            {obj.category} ({obj.count < 10 ? "0" + obj.count : obj.count})
          </Paragraph>
        </div>
      ))}
    </div>
  );
};

export default BlogCategories;
